import {API_ENDPOINT}  from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = process.env.REACT_APP_API_BASE_URL

export const  cashfreeApi = async(data) => {
  const res = await requestInstance.post(
    `${env}${API_ENDPOINT.cashfree.api}`,
    data
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

export const cashfreeResponseApi = async (data) => {
  const res = await requestInstance
  .post(`${env}${API_ENDPOINT.cashfree.verify}`,data)
  .catch((err) => err.response);
  return setCurrentUser(res);
}